const ComplexAreaMapRenderer = (props) => (<></>);

const getColorByAge = (age) => {
  if (age <= 1) {
    return "#E91E63"; // Pink-500
  } else if (age <= 5) {
    return "#D32F2F"; // Red-700
  } else if (age <= 10) {
    return "#EF6C00"; // Orange-800
  } else if (age <= 15) {
    return "#689F38"; // LightGreen-700
  } else if (age <= 20) {
    return "#2E7D32"; // Green-800
  } else if (age <= 25) {
    return "#00796B"; // Teal-700
  } else if (age <= 30) {
    return "#0277BD"; // Blue-800
  } else {
    return "#283593"; // Indigo-800
  }
};

const renderComplexArea = (complex, complexAreaPriceCounts, onClick) => {
  const cpx = complex;
  const element = document.createElement("div");
  element.style.position = "absolute";
  element.style.background = "#fff";
  element.style.zIndex = 1;
  element.style.transform = "translate(-50%,-30px)";
  element.className = `apt-area-info ${cpx.selected ? "active" : ""}`;
  element.id = `apt-area-info-${cpx.id}`;
  element.dataset.id = cpx.id;
  /* TABLE */
  const table = document.createElement("table");
  // table.style.width = "100%";
  table.style.fontSize = 12 + "px";
  table.className = "bordered";
  /* NAME */
  let trName = document.createElement("tr");
  let tdName = document.createElement("td");
  tdName.colSpan = 3;
  tdName.style.padding = 0;
  tdName.style.lineHeight = 1.1;
  tdName.style.fontWeight = "bold";
  tdName.style.paddingTop = "2px";
  tdName.style.background = getColorByAge(cpx.age);
  tdName.style.color = "#fff";
  tdName.style.cursor = "pointer";
  tdName.innerHTML = `${cpx.landmark ? "*" : ""}${cpx.name}${cpx.bookmark ? "*" : ""}<br/>${cpx.approvedYear}(${cpx.age}년차) / ${cpx.totalHouseholdCount.toLocaleString('ko-KR')}세대`;
  tdName.dataset.id = cpx.id;
  tdName.onclick = (e) => {
    const els = document.querySelectorAll(".apt-area-info");
    els.forEach(el => {
      el.className = el.className.replace("active", "").trim();
    });
    const el = document.querySelector(`#apt-area-info-${e.currentTarget.dataset.id}`);
    el.className += " active";
    onClick && onClick(el);
  };
  trName.appendChild(tdName);
  table.appendChild(trName);

  for (let i = 0; i < complexAreaPriceCounts.length; i++) {
    const area = complexAreaPriceCounts[i];
    const isTargetArea = (area.generalExclusiveArea > 50 && area.generalExclusiveArea < 90);
    const isStandardArea = (area.generalExclusiveArea >= 81 && area.generalExclusiveArea <= 86) || (area.supplyPyeong >= 31 && area.supplyPyeong <= 34);
    /* PRICE */
    let tr = document.createElement("tr");
    tr.style.lineHeight = 1.2;
    tr.className = (isTargetArea) ? "interesting-area-row" : "ordinary-area-row";
    tr.innerHTML += `<td style="min-width:60px;">${window.Math.floor(area.supplyPyeong)}평(${area.generalExclusiveArea})</td>`;
    tr.innerHTML += `<td style="min-width:40px;">${(area.dealPrice / 10000).toFixed(1)}</td>`;
    tr.innerHTML += `<td style="min-width:40px;">${(area.leasePrice / 10000).toFixed(1)}</td>`;
    if (isStandardArea) tr.className += " bold";
    table.appendChild(tr);
  }

  element.appendChild(table);
  return {
    element,
    latitude: cpx.latitude,
    longitude: cpx.longitude
  }
};

export { ComplexAreaMapRenderer, renderComplexArea };
